import { HugeiconsIcon } from '@hugeicons/react';
import {
  Activity01Icon,
  AnalyticsUpIcon,
  BookOpen01Icon,
  ColorPickerIcon,
  DashboardCircleIcon,
  DatabaseIcon,
  FileAddIcon,
  Mortarboard01Icon,
  Radar01Icon,
  Resize01Icon,
  Search01Icon,
  Settings01Icon,
  Shield01Icon,
  Target01Icon,
  TestTubeIcon,
} from '@hugeicons/core-free-icons';
import { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router';
import {
  CommandDialog,
  CommandInput,
  CommandList,
  CommandEmpty,
  CommandGroup,
  CommandItem,
} from '@/components/ui/command';
import { Button } from '@/components/ui/button';

const QUICK_ACTIONS = [
  { label: 'Knowledge Hub', to: '/kb', icon: BookOpen01Icon, group: 'Navegar' },
  { label: 'Identidad UC CHRISTUS', to: '/brand', icon: ColorPickerIcon, group: 'Navegar' },
  { label: 'Dashboard ejecutivo', to: '/dashboard', icon: DashboardCircleIcon, group: 'Navegar' },
  { label: 'AI Registry', to: '/registro', icon: DatabaseIcon, group: 'Navegar' },
  { label: 'Comité de IA', to: '/comite', icon: Resize01Icon, group: 'Navegar' },
  { label: 'Shadow AI', to: '/shadow-ai', icon: Radar01Icon, group: 'Navegar' },
  { label: 'Monitoreo de valor', to: '/valor', icon: AnalyticsUpIcon, group: 'Navegar' },
  { label: 'Academia y comunidad VIA', to: '/adopcion', icon: Mortarboard01Icon, group: 'Adopción' },
  { label: 'Sandbox seguro y Prompt Studio', to: '/sandbox', icon: TestTubeIcon, group: 'Adopción' },
  { label: 'Incidentes de IA', to: '/incidentes', icon: Shield01Icon, group: 'Gobernanza' },
  { label: 'Vigilancia continua', to: '/vigilancia', icon: Activity01Icon, group: 'Gobernanza' },
  { label: 'Madurez y hoja de ruta', to: '/madurez', icon: Target01Icon, group: 'Gobernanza' },
  { label: 'Registrar nueva iniciativa', to: '/registro/nueva', icon: FileAddIcon, group: 'Acciones' },
  { label: 'Administración', to: '/admin', icon: Settings01Icon, group: 'Navegar' },
];

/**
 * CommandSearch — Global command palette (Cmd+K / Ctrl+K).
 * Inspired by Watershed's prompt bar and Linear's command palette.
 */
export function CommandSearch() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const down = (e) => {
      if (e.key === 'k' && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setOpen((prev) => !prev);
      }
    };
    document.addEventListener('keydown', down);
    return () => document.removeEventListener('keydown', down);
  }, []);

  const handleSelect = useCallback(
    (to) => {
      setOpen(false);
      navigate(to);
    },
    [navigate],
  );

  const groups = QUICK_ACTIONS.reduce((acc, item) => {
    if (!acc[item.group]) acc[item.group] = [];
    acc[item.group].push(item);
    return acc;
  }, {});

  return (
    <>
      <Button
        variant="outline"
        onClick={() => setOpen(true)}
        className="h-9 px-3 gap-2 text-xs text-white/70 border-white/20 bg-white/10 hover:bg-white/20 hover:text-white"
        aria-label="Buscar o navegar (Ctrl+K)">
        <HugeiconsIcon icon={Search01Icon} className="h-3.5 w-3.5" aria-hidden="true" />
        <span className="hidden sm:inline">Buscar...</span>
        <kbd className="hidden sm:inline-flex h-5 items-center gap-0.5 rounded border border-white/20 bg-white/10 px-1.5 text-[10px] font-medium text-white/70">
          ⌘K
        </kbd>
      </Button>

      <CommandDialog open={open} onOpenChange={setOpen}>
        <CommandInput placeholder="Buscar páginas, acciones, recursos..." />
        <CommandList>
          <CommandEmpty>Sin resultados. Intenta con otro término.</CommandEmpty>
          {Object.entries(groups).map(([group, items]) => (
            <CommandGroup key={group} heading={group}>
              {items.map((item) => (
                <CommandItem key={item.to} onSelect={() => handleSelect(item.to)} className="gap-3">
                  <HugeiconsIcon icon={item.icon} className="h-4 w-4 text-muted-foreground" aria-hidden="true" />
                  <span>{item.label}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          ))}
        </CommandList>
      </CommandDialog>
    </>
  );
}
